import ErrorPageTemplate from "../../components/ErrorPageTemplate";
import { AuthContextProps } from "oidc-react";

interface LoggedOutPageProps {
    auth?: AuthContextProps;
}

const LoggedOutPage = ({ auth }: LoggedOutPageProps) => {
    return (
        <ErrorPageTemplate
            errorImage="img/session_expired.png"
            errorDescription={"⏲️ Oops! O tempo passou mais rápido do que imaginávamos!\nVamos reiniciar e seguir em frente de onde paramos? 🔁"}
            buttonText="Entrar novamente na aplicação"
            buttonLink="/login"
        />
    );
};

export default LoggedOutPage;